export const EventOptions = [
    { label: 'AD connector created', value: 'AD connector created' },
    {
        label: 'AD connector created authentication token',
        value: 'AD connector created authentication token',
    },
    { label: 'AD connector deleted', value: 'AD connector deleted' },
    {
        label: 'AD connector sync rules changed',
        value: 'AD connector sync rules changed',
    },
    { label: 'Admin user added', value: 'Admin user added' },
    { label: 'Admin user removed', value: 'Admin user removed' },
    { label: 'Backup file downloaded', value: 'Backup file downloaded' },
    { label: 'Company added', value: 'Company added' },
    { label: 'Company changed', value: 'Company changed' },
    { label: 'Company group added', value: 'Company group added' },
    { label: 'Company group changed', value: 'Company group changed' },
    { label: 'Company group removed', value: 'Company group removed' },
    { label: 'Device added', value: 'Device added' },
    { label: 'Device deleted', value: 'Device deleted' },
    { label: 'Group added', value: 'Group added' },
    { label: 'Group deleted', value: 'Group deleted' },
    { label: 'Group modified', value: 'Group modified' },
    {
        label: 'Groups managed in CyberFOX Password Manager',
        value: 'Groups managed in Password Boss',
    },
    { label: 'Partner portal user added', value: 'Partner portal user added' },
    {
        label: 'Partner portal user changed',
        value: 'Partner portal user changed',
    },
    {
        label: 'Partner portal user removed',
        value: 'Partner portal user removed',
    },
    { label: 'Password change required', value: 'Password change required' },
    { label: 'Password reset', value: 'Password reset' },
    { label: 'Payment info updated', value: 'Payment info updated' },
    { label: 'Portal login', value: 'Portal login' },
    { label: 'Portal password changed', value: 'Portal password changed' },
    { label: 'Role changed', value: 'Role changed' },
    { label: 'Role created', value: 'Role created' },
    { label: 'Role removed', value: 'Role removed' },
    { label: 'Security policy changed', value: 'Security policy changed' },
    { label: 'Share changed', value: 'Share changed' },
    { label: 'Share created', value: 'Share created' },
    { label: 'Share deleted', value: 'Share deleted' },
    {
        label: 'Subscription level changed',
        value: 'Subscription level changed',
    },
    {
        label: 'Business profile name changed',
        value: 'Business profile name changed',
    },
    { label: 'Update payment method', value: 'Update payment method' },
    { label: 'User added', value: 'User added' },
    { label: 'User changed', value: 'User changed' },
    {
        label: 'User converted to personal account',
        value: 'User converted to personal account',
    },
    { label: 'User deleted', value: 'User deleted' },
    { label: 'User disabled', value: 'User disabled' },
    { label: 'User re-enabled', value: 'User re-enabled' },
    {
        label: 'Users managed in CyberFOX Password Manager',
        value: 'Users managed in Password Boss',
    },
];

export const PAActionOptions = [
    { label: 'Password changed', value: 'Password changed' },
    { label: 'Password copied', value: 'Password copied' },
    { label: 'Password created', value: 'Password created' },
    { label: 'Password deleted', value: 'Password deleted' },
    { label: 'Password exported', value: 'Password exported' },
    { label: 'Password imported', value: 'Password imported' },
    { label: 'Password used', value: 'Password used' },
    { label: 'Password viewed', value: 'Password viewed' },
];
